import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';
import { environment } from 'src/environments/environment';
import { DiagnosisDetail, TriageHistory } from '../models/patientHealth';

/** Vitais, triagem e análise de sintomas que o totem já gravou, para o atendente ver durante a chamada. */
@Injectable({
  providedIn: 'root'
})
export class PatientHealthService {
  private readonly clinicalMetricsUrl = `${environment.apiUrlBase}${environment.microservices.clinicalMetrics}`;
  private readonly drOliveUrl = `${environment.apiUrlBase}${environment.microservices.drolive}DrOlive`;

  constructor(private readonly http: HttpClient) {}

  /**
   * Última triagem do usuário, com os vitais da mesma sessão.
   * ponytail: busca pelo userId da fila; no anônimo (uma conta para todos os totens) o último registro
   * pode ser de outro paciente. Exato exige o sessionId do totem no atendimento.
   */
  getTriage(userId: string): Observable<TriageHistory | null> {
    return this.http
      .get<ResponseDefault<TriageHistory[]>>(`${this.clinicalMetricsUrl}triage/history`, {
        params: { userId, limit: 1 }
      })
      .pipe(
        map((response) => response?.data?.[0] ?? null),
        catchError(() => of(null))
      );
  }

  /** Último diagnóstico do Dr. Olive do usuário, com evidências, hipóteses e especialista. */
  getLatestDiagnosis(userId: string): Observable<DiagnosisDetail | null> {
    return this.http
      .get<{ result?: DiagnosisDetail[] }>(`${this.drOliveUrl}/users/${userId}/diagnoses`, {
        params: { pageNumber: 1, itensPerPage: 1 }
      })
      .pipe(
        map((page) => page?.result?.[0] ?? null),
        catchError(() => of(null))
      );
  }
}
